import { morePacks } from './morePacks';
import { HOME_BODIES } from './homeBodies';

export { SITE_LANGS, SITE_LANG_CODES, SITE_LANG_NAMES, SITE_LANG_HINTS } from './meta';

const EN = {
  how: 'How it works',
  services: 'Services',
  languages: 'Languages',
  findHospitals: 'Find hospitals',
  costCalculator: 'Cost calculator',
  cancerGuides: 'Cancer Guides',
  forHospitals: 'For hospitals',
  signIn: 'Sign in',
  joinWaitlist: 'Join waitlist',
  account: 'Account',
  talk: 'Talk to Vani',
  openApp: 'Get Started',
  openTheApp: 'Get Started Free',
  seeHow: 'See how it works',
  langStatWrite: 'languages you can write in',
  langStatSpeak: 'languages you can speak',
  product: 'Product',
  company: 'Company',
  coverage: 'Coverage',
  pricing: 'Pricing',
  hold: 'Hold to talk',
  listening: 'Listening…',
  signInToAsk: 'Sign in to ask Vani.',
  notHeard: 'I did not catch that. Try again, or type.',
  emergencyTitle: 'This may be an emergency',
  langLabel: 'Language',
  voiceUnavailable: 'Voice is unavailable right now',
  heardConfirm: 'I heard',
  heardRight: 'Is that right?',
  confirmYes: 'Yes',
  confirmNo: 'No',
  heardWrong: 'Please type the question, or hold to talk again.',
  splashMark: 'byonco',
  splashAttrib: '',
  splashThesis: 'Solving Cancer Care in 2026.',
  splashLine1: 'We get cancer patients',
  splashLine2: 'to specialists, the fastest.',
  splashSkip: 'Skip',
  splashSr: 'ByOnco. Solving Cancer Care in 2026. We get cancer patients to specialists, the fastest.',
  contact: 'Contact',
  privacy: 'Privacy',
  terms: 'Terms',
  security: 'Security',
  rareCancers: 'Rare cancers',
  teleconsultation: 'Teleconsultation',
  journeyBuilder: 'Journey builder',
  marketplace: 'Care marketplace',
  talkToVani: 'Talk to Vani',
  talkTeam: 'Talk to the team',
  builtInIndia: 'Built for patients, wherever care takes them.',
  footerBlurb: 'An oncology companion for patients and families, in the language you think in.',
  footerDisclaimer: 'Vani helps you understand cancer care in plain language, so you walk into clinic ready with clearer questions.',
  footerEmergency: 'In a US emergency call 911; for crisis support call or text 988.',
  trainedBy: 'trained by oncologists and health care professionals',
  trainedOncologists: 'trained by oncologists',
  voiceReply: 'Voice reply',
  textReply: 'Text reply',
  heroLine1: 'The complete navigation platform',
  heroLine2: 'for cancer care.',
  heroLede: 'Understand your diagnosis, match top cancer centers, calculate true costs, and get 24/7 guidance in your native language.',
  askWriting: 'Ask in writing in {n} languages.',
  speakInLangs: 'Speak in any of {n} languages.',
  langSub: 'English is the default for US care. Type in any of {n} languages below. Voice replies today in English, Hindi, Hinglish, and Marathi.',
  cancerTypesCovered: 'cancer types covered',
  hospitalsMapped: 'hospitals mapped',
  secondOpinions: 'expert second opinions',
  problemEyebrow: 'The problem',
  problemH2: "The questions don't arrive during clinic hours.",
  problemP1: 'Tuesday at Memorial Hermann in Houston: twenty minutes, then the oncologist is gone until Thursday. At 2:14 a.m. in Sugar Land, her daughter has the portal note open on the guest-room floor, googling what her mother can eat on FOLFOX. The first results are NHS pages.',
  problemP2: 'The attending already went home. The person who has to decide about dinner, and about a fever of 101, is the daughter who drove.',
  problemQuote: "She's on FOLFOX this cycle. What do I actually feed her, and when is a fever an ER visit?",
  problemAttr: 'Sugar Land, Texas. 2:14 a.m., two nights after infusion at Memorial Hermann.',
  howEyebrow: 'How it works',
  howH2: "Type a question. That's the whole interface.",
  howSub: 'No forms, no menus. Writing already works in {n} languages.',
  howAskH: 'Ask in your own words',
  howAskP: 'Write the way you speak, in any of {n} languages. Keep chemotherapy and platelets in English. English is the default for US care.',
  howAnswerH: 'Get a short, human answer',
  howAnswerP: 'Two or three sentences, spoken back the way someone sitting across the table would explain it. Short, human, and easy to take into clinic.',
  howRememberH: 'She remembers',
  howRememberP: "The cancer type, the regimen, which cycle you're on, your city, whether you're the patient or the son. Come back next week and you carry on. Nobody re-explains their mother's diagnosis to a machine twice.",
  langEyebrow: 'Languages',
  scopeEyebrow: 'Coverage',
  scopeH2: 'Cancer types, and the whole life around them.',
  scopeH2n: '{n} cancer types, and the whole life around them.',
  scopeSub: 'Including the rare ones, where families usually get the least help and need the most.',
  scopeUltra: 'Ultra-rare: DIPG, ATRT, SCCOHT, BPDCN',
  scopeVery: 'Very rare: chordoma, angiosarcoma, uveal melanoma',
  scopeRare: 'Rare: GIST, mesothelioma, Ewing sarcoma',
  scopeCommon: 'Common and less common: breast, lung, colorectal, myeloma',
  cardTreatH: 'Treatment and transplant',
  cardTreatP: 'Surgery, chemotherapy, radiation, targeted and immunotherapy. Bone marrow and stem cell transplant in full: donor matching, conditioning, engraftment, the isolation weeks, GVHD, and life afterwards. CAR-T, clinical trials, genomic testing.',
  cardWarnH: 'The parts nobody warns you about',
  cardWarnP: "What to eat when nothing tastes right. Whether it's safe to travel between cycles. Going back to work. Intimacy and fertility. Hair, skin, stoma and lymphoedema care. Fear of recurrence at 3am. Caregivers who haven't slept.",
  cardMoneyH: 'Money and logistics',
  cardMoneyP: 'US insurance language first: Medicare, Medicaid, commercial plans. Then hospital matching, cost estimates, and India schemes including Ayushman Bharat when that is the question.',
  cardRareH: 'Rare cancers, without the shrug',
  cardRareP: 'DIPG, ATRT, chordoma, GIST and the rest that barely show up in waiting-room pamphlets. Plain words for the biology, what questions to take to the specialist, and how to look for a trial without false hope.',
  cardCareH: 'For the person next to them',
  cardCareP: 'The spouse in the waiting room, the adult child on the portal, the friend driving to radiation. How to tell a child, what to watch for at home, when to push for a second opinion, and how to keep yourself standing.',
  cardRefuseH: 'Clear Medical Scope',
  cardRefuseP: 'Focused entirely on cancer care education and navigation. We help you understand your diagnosis and coordinate closely with your treating oncologists.',
  safetyEyebrow: 'Safety & Trust',
  safetyH2: 'Built for 3:00 AM, when someone is frightened and needs clear answers.',
  safetySub: 'Built with strict medical boundaries and clinical precision at every step.',
  safetyRedK: 'Urgent Red Flags',
  safetyRedP: 'Emergencies and acute complications are flagged immediately. Symptoms like neutropenic fever, acute shortness of breath, or uncontrolled bleeding trigger clear prompts to seek emergency care right away.',
  safetyInventK: 'Verified Information',
  safetyInventP: 'Hospitals, physicians, pricing tables, and clinical trial listings are checked against verified registries. Treatment cost estimates come from transparent, structured data, never ungrounded guesses.',
  safetyBoundK: 'Doctor-Centered',
  safetyBoundP: 'Vani explains medical terms, scan results, and pathology reports in clear language, helping you prepare focused, high-priority questions for your oncologist.',
  safetyDistressK: 'Emotional Support',
  safetyDistressP: 'When feelings of anxiety or exhaustion take over, we connect you immediately with verified crisis hotlines and counseling support.',
  safetyPrivK: 'Your Privacy',
  safetyPrivP: 'Your medical details belong to you. Everything Vani stores is transparent inside the app, editable line by line, and can be permanently erased in a single tap.',
  priceEyebrow: 'Pricing',
  priceH2: 'Priced below a single US oncology visit.',
  priceSub: 'Plans start at $14.99 a month, marked down from $39.99. Cancel anytime.',
  planFree: 'Free',
  planFreeWho: 'Try it first',
  planFree1: '2 questions, no card',
  planFree2: 'All {n} languages',
  planFree3: 'Trained by experienced oncologists',
  planPro: 'ByOnco PRO',
  planProWho: 'Patients and families',
  planProTag: 'Most families choose this',
  planPro1: 'Unlimited questions in {n} languages',
  planPro2: 'US hospital and NCI-center matching',
  planPro3: 'Expert written second opinions (target within 12 hours)',
  planPro4: 'Cost estimates and insurance framing',
  planPro5: 'Check-ins, bookmarks, and analysis',
  startPro: 'Start PRO',
  planYearly: 'ByOnco PRO Yearly',
  planYearlyTag: 'Save 25%',
  planYearlyWho: 'Best for ongoing care',
  planYearly1: 'Everything in ByOnco PRO',
  planYearly2: 'Billed $179.88 once a year ($14.99/mo)',
  planYearly3: 'Save 25% vs monthly · cancel anytime',
  startYearly: 'Start Yearly',
  planLife: 'Lifetime',
  planLifeWho: 'One payment',
  planLife1: 'Everything in PRO, forever',
  planLife2: 'No renewals',
  planLife3: 'For families in this for years',
  getLifetime: 'Get lifetime',
  saasLine: 'Cancer centers: Hospital SaaS at $10,000/month for international referrals, bed and queue analytics, conversion tracking, EMR integration.',
  requestDemo: 'Request a demo',
  faqEyebrow: 'Questions',
  faqH2: 'The things people ask us first.',
  faq1q: 'Is this a replacement for an oncologist?',
  faq1a: "No, and it is deliberately designed so it never tries to be. Vani never diagnoses, never prescribes doses, and never tells anyone to start, stop, or change treatments. She answers the practical questions that come up between clinic appointments, so your time with your oncologist is focused on what matters most.",
  faq2q: 'How do you stop it from making things up?',
  faq2a: "Hospitals, doctors, prices, and clinical trials are the highest-risk details an AI can invent. Vani is strictly prohibited from answering these from memory. Hospital recommendations are matched directly against our verified directory of NCI-designated cancer centers. Treatment costs come from structured calculation tables. If she does not know something, she says so honestly.",
  faq3q: 'What happens to my medical information?',
  faq3a: "Everything Vani remembers about your care is completely visible in the app, editable line by line, and erasable with a single tap. We never sell health data. All data handling is HIPAA-ready in the US and aligns with the DPDP Act in India.",
  faq4q: 'Do you only work in English?',
  faq4a: 'Ask in writing in {n} languages. English is the default for the US.',
  faq5q: 'Who is this for?',
  faq5a: 'Patients and caregivers. The person sitting in an infusion chair, the daughter driving to the hospital, the spouse looking something up at 2am. If cancer is part of your life, this is for you.',
  closeH2: 'Nobody should have to face this between Thursday and the next portal message.',
  closeSub: 'Choose a plan to get started. It takes about a minute.',
  ourServices: 'Our services',
  servicesH2: 'Complete cancer care, beyond the conversation',
  servicesLead: 'ByOnco matches you to US hospitals, USD cost tables, rare-cancer pathways, second opinions, and care packages.',
  howByonco: 'How ByOnco works',
  howByoncoH2: 'How ByOnco Works',
  howByoncoLead: 'From matching to insurance help. Here is how we guide your cancer journey.',
  specializedCare: 'Specialized care',
  rareUltraH2: 'Rare and ultra-rare cancer expertise',
  rareSpecialize: 'We specialize in {n} rare cancer types',
  rareMapped: ', mapped across {n} centers.',
  viewRare: 'View all rare cancers',
  fullMarketplace: 'Full care marketplace',
  teamEyebrow: 'Built by a world-class team',
  teamTag: 'Built by people who understand your pain, powered by people who can solve it',
  saasLead: 'Cancer centers:',
  saasBold: 'Hospital SaaS at $10,000/month',
  saasRest: 'for international referrals, bed and queue analytics, conversion tracking, EMR integration.',
  hospTitle: 'For hospitals',
  hospDesc: 'Hospital SaaS at $10,000 a month: qualified international referrals, conversion tracking, bed and queue analytics, and EMR integration.',
  hospPill: 'Hospital SaaS',
  hospH1: 'A B2B door that does not hide behind a microphone.',
  hospLede: 'Qualified international referrals, conversion tracking, bed and queue analytics, and EMR integration. This is what outbound sends. Partners do not scroll past a voice demo to see a business.',
  hospMarketplace: 'See the care marketplace',
  hospSkuEyebrow: 'The SKU',
  hospSkuH2: 'Hospital SaaS at $10,000 a month.',
  hospSkuSub: 'Live today. Same money path as the rest of ByOnco.',
  hospRefH: 'International referrals',
  hospRefP: 'Qualified inbound cases with documentation packets, ready for coordinators to act.',
  hospBedsH: 'Beds, queues, conversion',
  hospBedsP: 'See which referrals convert, where they stall, and what the coordinator still needs.',
  hospEmrH: 'EMR integration',
  hospEmrP: 'Account-managed onboarding. Dedicated support. The forest-green door stays first-class in nav and footer.',
  hospPartners: 'Talk to partnerships',
};

function pack(over) {
  return { ...EN, ...over };
}

function overlayBodies(packs) {
  return Object.fromEntries(
    Object.entries(packs).map(([code, p]) => [code, { ...p, ...(HOME_BODIES[code] || {}) }])
  );
}

const SITE = {
  en: EN,
  es: pack({
    how: 'Cómo funciona',
    services: 'Servicios',
    languages: 'Idiomas',
    findHospitals: 'Buscar hospitales',
    costCalculator: 'Calculadora de costos',
    cancerGuides: 'Guías de cáncer',
    forHospitals: 'Para hospitales',
    signIn: 'Iniciar sesión',
    talk: 'Hablar con Vani',
    openApp: 'Comenzar',
    openTheApp: 'Comenzar gratis',
    seeHow: 'Ver cómo funciona',
    langStatWrite: 'idiomas para escribir',
    langStatSpeak: 'idiomas para hablar',
    product: 'Producto',
    company: 'Empresa',
    coverage: 'Cobertura',
    pricing: 'Precios',
    langLabel: 'Idioma',
    contact: 'Contacto',
    privacy: 'Privacidad',
    terms: 'Términos',
    security: 'Seguridad',
    rareCancers: 'Cánceres raros',
    teleconsultation: 'Teleconsulta',
    journeyBuilder: 'Plan de viaje',
    marketplace: 'Mercado de cuidado',
    talkToVani: 'Hablar con Vani',
    talkTeam: 'Hablar con el equipo',
    builtInIndia: 'Hecho en India',
    footerBlurb: 'Un compañero de oncología para pacientes y familias, en el idioma en el que piensas.',
    footerDisclaimer: 'Vani ofrece información general sobre el cáncer y su cuidado. No diagnostica, no receta y no sustituye a tu oncólogo.',
    footerEmergency: 'En una emergencia en EE. UU. llama al 911; para crisis, llama o envía un mensaje al 988.',
    trainedBy: 'entrenada por oncólogos y profesionales de la salud',
    trainedOncologists: 'entrenada por oncólogos',
    voiceReply: 'Respuesta de voz',
    textReply: 'Respuesta escrita',
    heroLine1: 'La plataforma completa de navegación',
    heroLine2: 'para el cuidado del cáncer.',
    heroLede: 'Comprende tu diagnóstico, encuentra centros oncológicos líderes, calcula costos reales y recibe orientación 24/7 en tu idioma nativo.',
    askWriting: 'Escribe en {n} idiomas.',
    speakInLangs: 'Habla en cualquiera de {n} idiomas.',
    langSub: 'El inglés es el idioma por defecto para el cuidado en EE. UU. Escribe en cualquiera de los {n} idiomas de abajo. Hoy Vani responde en voz en inglés, hindi, hinglish y maratí.',
    cancerTypesCovered: 'tipos de cáncer cubiertos',
    hospitalsMapped: 'hospitales mapeados',
    secondOpinions: 'segundas opiniones expertas',
    problemEyebrow: 'El problema',
    problemH2: 'Las preguntas no llegan en horario de consulta.',
    problemP1: 'Martes en Memorial Hermann en Houston: veinte minutos, y el oncólogo no vuelve hasta el jueves. A las 2:14 a. m. en Sugar Land, su hija tiene la nota del portal abierta en el suelo de la habitación de huéspedes, buscando qué puede comer su madre en FOLFOX. Los primeros resultados son páginas del NHS.',
    problemP2: 'El médico ya se fue a casa. Quien tiene que decidir la cena, y una fiebre de 101, es la hija que condujo.',
    problemQuote: 'Está en FOLFOX este ciclo. ¿Qué le doy de comer de verdad, y cuándo una fiebre es una visita a urgencias?',
    problemAttr: 'Sugar Land, Texas. 2:14 a. m., dos noches después de la infusión en Memorial Hermann.',
    howEyebrow: 'Cómo funciona',
    howH2: 'Escribe una pregunta. Esa es toda la interfaz.',
    howSub: 'Sin formularios ni menús. Ya puedes escribir en {n} idiomas.',
    howAskH: 'Pregunta con tus palabras',
    howAskP: 'Escribe como hablas, en cualquiera de {n} idiomas. Deja chemotherapy y platelets en inglés. El inglés es el idioma por defecto para el cuidado en EE. UU.',
    howAnswerH: 'Una respuesta corta y humana',
    howAnswerP: 'Dos o tres frases, como alguien sentado frente a ti. No un muro de texto, no una lista de advertencias, y nunca un diagnóstico.',
    howRememberH: 'Ella recuerda',
    howRememberP: 'El tipo de cáncer, el régimen, el ciclo, tu ciudad, si eres el paciente o el hijo. Vuelve la semana que viene y sigues. Nadie explica dos veces el diagnóstico de su madre a una máquina.',
    langEyebrow: 'Idiomas',
    scopeEyebrow: 'Cobertura',
    scopeH2: 'Tipos de cáncer, y toda la vida alrededor.',
    scopeH2n: '{n} tipos de cáncer, y toda la vida alrededor.',
    scopeSub: 'Incluidos los raros, donde las familias suelen recibir menos ayuda y necesitan más.',
    scopeUltra: 'Ultra raros: DIPG, ATRT, SCCOHT, BPDCN',
    scopeVery: 'Muy raros: cordoma, angiosarcoma, melanoma uveal',
    scopeRare: 'Raros: GIST, mesotelioma, sarcoma de Ewing',
    scopeCommon: 'Comunes y menos comunes: mama, pulmón, colorrectal, mieloma',
    cardTreatH: 'Tratamiento y trasplante',
    cardTreatP: 'Cirugía, quimioterapia, radiación, terapia dirigida e inmunoterapia. Trasplante de médula y células madre completo: emparejamiento de donante, acondicionamiento, injerto, las semanas de aislamiento, GVHD y la vida después. CAR-T, ensayos clínicos, pruebas genómicas.',
    cardWarnH: 'Lo que nadie avisa',
    cardWarnP: 'Qué comer cuando nada sabe bien. Si es seguro viajar entre ciclos. Volver al trabajo. Intimidad y fertilidad. Cabello, piel, estoma y linfedema. Miedo a la recaída a las 3 a. m. Cuidadores que no han dormido.',
    cardMoneyH: 'Dinero y logística',
    cardMoneyP: 'Primero el lenguaje del seguro en EE. UU.: Medicare, Medicaid, planes comerciales. Luego emparejamiento de hospitales, estimaciones de costo y esquemas de India, incluido Ayushman Bharat, cuando esa es la pregunta.',
    cardRareH: 'Cánceres raros, sin el encogimiento de hombros',
    cardRareP: 'DIPG, ATRT, cordoma, GIST y el resto que casi no aparece en folletos de sala de espera. Palabras claras para la biología, qué preguntar al especialista y cómo buscar un ensayo sin falsa esperanza.',
    cardCareH: 'Para quien está al lado',
    cardCareP: 'La pareja en la sala de espera, el hijo adulto en el portal, el amigo que conduce a radiación. Cómo decírselo a un niño, qué vigilar en casa, cuándo pedir una segunda opinión y cómo mantenerte en pie.',
    cardRefuseH: 'Lo que ella rechaza',
    cardRefuseP: 'Todo lo que no es cáncer, en una línea. Sin diagnósticos, sin dosis, sin decir que empieces o pares un medicamento. Otras condiciones solo se responden donde tocan el tratamiento del cáncer.',
    safetyEyebrow: 'Seguridad',
    safetyH2: 'Hecha por gente que asume que se usará a las 3 a. m., con miedo.',
    safetySub: 'Gran parte de la ingeniería fue para lo que Vani no hará.',
    safetyRedK: 'Alertas',
    safetyRedP: 'Las emergencias van primero, a mitad de frase. Fiebre en neutropenia, falta de aire, sangrado fuerte, signos de GVHD tras un trasplante: la primera frase los manda a urgencias, y no se habla de nada más.',
    safetyInventK: 'Sin inventar',
    safetyInventP: 'Ningún hospital, médico, precio, ensayo o tiempo de espera se inventa. Los hospitales se verifican contra la base de ByOnco antes de reservar. Los costos van a una calculadora determinista, no a una conjetura.',
    safetyBoundK: 'Límites',
    safetyBoundP: 'Nunca un diagnóstico, nunca una dosis, nunca "deja ese medicamento". Puede explicar qué significa una palabra de tu informe; no te dirá qué significa tu informe. Eso le corresponde a tu oncólogo.',
    safetyDistressK: 'Angustia',
    safetyDistressP: 'La desesperanza se responde con cuidado, no con un desvío. En EE. UU.: 988 y 911. En India: 108. Donde no podemos verificar un número, lo decimos en vez de inventarlo.',
    safetyPrivK: 'Privacidad',
    safetyPrivP: 'Tu memoria es tuya. Todo lo que Vani sabe se ve en la app, se puede editar y borrar de un toque.',
    priceEyebrow: 'Precios',
    priceH2: 'Por debajo de una sola visita de oncología en EE. UU.',
    priceSub: 'Planes desde $14.99 al mes, rebajado de $39.99. Cancela cuando quieras.',
    planFree: 'Gratis',
    planFreeWho: 'Pruébalo primero',
    planFree1: '2 preguntas, sin tarjeta',
    planFree2: 'Los {n} idiomas',
    planFree3: 'Entrenada por oncólogos con experiencia',
    planProWho: 'Pacientes y familias',
    planProTag: 'La mayoría de las familias elige esto',
    planPro1: 'Preguntas ilimitadas en {n} idiomas',
    planPro2: 'Emparejamiento con hospitales NCI de EE. UU.',
    planPro3: 'Segundas opiniones en menos de 12 horas',
    planPro4: 'Estimaciones de costo y marco de seguro',
    planPro5: 'Check-ins, marcadores y análisis',
    startPro: 'Empezar PRO',
    planYearly: 'ByOnco PRO Anual',
    planYearlyTag: 'Ahorra 25%',
    planYearlyWho: 'Mejor para cuidado continuo',
    planYearly1: 'Todo en ByOnco PRO',
    planYearly2: 'Facturado $179.88 al año ($14.99/mes)',
    planYearly3: 'Ahorra 25% vs mensual · cancela cuando quieras',
    startYearly: 'Empezar Anual',
    planLife: 'De por vida',
    planLifeWho: 'Un solo pago',
    planLife1: 'Todo de PRO, para siempre',
    planLife2: 'Sin renovaciones',
    planLife3: 'Para familias que estarán en esto años',
    getLifetime: 'Obtener de por vida',
    saasLine: 'Centros de cáncer: Hospital SaaS a $10,000/mes para referidos internacionales, analítica de camas y filas, seguimiento de conversión e integración EMR.',
    requestDemo: 'Pedir una demo',
    faqEyebrow: 'Preguntas',
    faqH2: 'Lo primero que nos preguntan.',
    faq1q: '¿Esto reemplaza a un oncólogo?',
    faq1a: 'No, y está hecha para que no pueda convertirse en uno. Vani nunca diagnostica, nunca da una dosis y nunca dice que empieces, pares o cambies un tratamiento. Responde las preguntas que se acumulan entre visitas en EE. UU., para que los veinte minutos con tu oncólogo se usen en lo que de verdad los necesita.',
    faq2q: '¿Cómo evitan que invente?',
    faq2a: 'Hospitales, médicos, precios, ensayos y tiempos de espera son lo más peligroso que un modelo puede inventar, así que no puede producirlos de memoria. Los nombres de hospitales se contrastan con el directorio verificado de ByOnco, centros NCI de EE. UU. primero. Los costos van a una calculadora determinista. Donde no sabe, lo dice.',
    faq3q: '¿Qué pasa con mi información médica?',
    faq3a: 'Todo lo que Vani recuerda de ti es visible en la app, editable línea por línea y se puede borrar de un toque. No vendemos datos de salud. En EE. UU. operamos con una postura lista para HIPAA; en India también aplica la DPDP Act.',
    faq4q: '¿Solo funciona en inglés?',
    faq4a: 'Escribe en {n} idiomas. El inglés es el idioma por defecto para EE. UU.',
    faq5q: '¿Para quién es esto?',
    faq5a: 'Pacientes y cuidadores. Quien está en la silla de infusión, la hija que maneja al hospital, la pareja que busca algo a las 2 a. m. Si el cáncer es parte de tu vida, esto es para ti.',
    closeH2: 'Nadie debería enfrentar esto entre el jueves y el siguiente mensaje del portal.',
    closeSub: 'Elige un plan para empezar. Toma un minuto.',
    ourServices: 'Nuestros servicios',
    servicesH2: 'Cuidado oncológico completo, más allá de la conversación',
    servicesLead: 'ByOnco te conecta con hospitales de EE. UU., tablas de costos en USD, vías para cánceres raros, segundas opiniones y paquetes de cuidado.',
    howByonco: 'Cómo funciona ByOnco',
    howByoncoH2: 'Cómo funciona ByOnco',
    howByoncoLead: 'Del emparejamiento a la ayuda con el seguro. Así guiamos tu camino.',
    specializedCare: 'Cuidado especializado',
    rareUltraH2: 'Experiencia en cánceres raros y ultra raros',
    rareSpecialize: 'Nos especializamos en {n} tipos de cáncer raro',
    rareMapped: ', mapeados en {n} centros.',
    viewRare: 'Ver todos los cánceres raros',
    fullMarketplace: 'Mercado de cuidado completo',
    teamEyebrow: 'Hecho por un equipo de primer nivel',
    teamTag: 'Hecho por gente que entiende el dolor, impulsado por gente que puede resolverlo',
    saasLead: 'Centros de cáncer:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'para referidos internacionales, analítica de camas y filas, seguimiento de conversión e integración EMR.',
    hospTitle: 'Para hospitales',
    hospDesc: 'Hospital SaaS a $10,000 al mes: referidos internacionales calificados, seguimiento de conversión, analítica de camas y filas, e integración EMR.',
    hospPill: 'Hospital SaaS',
    hospH1: 'Una puerta B2B que no se esconde detrás de un micrófono.',
    hospLede: 'Referidos internacionales calificados, seguimiento de conversión, analítica de camas y filas, e integración EMR. Esto es lo que se envía hacia afuera. Los socios no tienen que pasar un demo de voz para ver un negocio.',
    hospMarketplace: 'Ver el mercado de cuidado',
    hospSkuEyebrow: 'El SKU',
    hospSkuH2: 'Hospital SaaS a $10,000 al mes.',
    hospSkuSub: 'En vivo. No es una lista de espera. El mismo camino de pago que el resto de ByOnco.',
    hospRefH: 'Referidos internacionales',
    hospRefP: 'Casos de entrada calificados con paquetes de documentación, no un sitio de folleto y una esperanza.',
    hospBedsH: 'Camas, filas, conversión',
    hospBedsP: 'Ve qué referidos convierten, dónde se traban y qué le falta al coordinador.',
    hospEmrH: 'Integración EMR',
    hospEmrP: 'Onboarding con cuenta dedicada. Soporte dedicado. La puerta verde se queda de primera en la navegación y el pie.',
    hospPartners: 'Hablar con partnerships',
  }),
  ...overlayBodies(morePacks(pack)),
};

export function sitePack(lang) {
  const code = String(lang || 'en').split('-')[0];
  return SITE[code] || SITE.en;
}
